import { message } from 'antd'
import queryString from 'query-string'

export const getQueryString = (query) => {
  const result = queryString.stringify(query)

  if (!result) return ''
  return `?${result}`
}
export const copyToClipboard = (textToCopy) => {
  message.success('Sao chép thành công!')

  // navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
    // navigator clipboard api method'
    return navigator.clipboard.writeText(textToCopy)
  } else {
    // text area method
    let textArea = document.createElement('textarea')
    textArea.value = textToCopy
    // make the textarea out of viewport
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    return new Promise((res, rej) => {
      // here the magic happens
      document.execCommand('copy') ? res() : rej()
      textArea.remove()
    })
  }
}
export const xoa_dau = (str) => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
  str = str.replace(/đ/g, 'd')
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A')
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E')
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I')
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O')
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U')
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y')
  str = str.replace(/Đ/g, 'D')
  return str
}
export const number_to_price = (v = 0) => {
  if (v === 0) {
    return '0'
  }

  if (!v || v === '') {
    return v
  }
  v = v.toString()

  v = v.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')

  v = v.split('.').join(',').split(',').join('*').split('*').join('.')
  return v
}

const TWO_DIGIT_LENGTH = 2
const TWO_DIGIT_PAD_CHARACTER = '0'

export function formatTwoDigitValue(value, fallbackValue) {
  return typeof value === 'number' ? String(value).padStart(TWO_DIGIT_LENGTH, TWO_DIGIT_PAD_CHARACTER) : fallbackValue
}

export function trimStrings(obj) {
  if (typeof obj === 'string') {
    return obj.trim()
  } else if (Array.isArray(obj)) {
    return obj.map(trimStrings)
  } else if (typeof obj === 'object' && obj !== null) {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = trimStrings(obj[key])
      return acc
    }, {})
  }

  return obj
}

export function isEmptyText(text) {
  return (
    text === null || // localStorage không có key -> getItem trả về null
    text === undefined || // phòng trường hợp undefined
    text === '' || // chuỗi rỗng
    text.toLowerCase() === 'null' ||
    text.toLowerCase() === 'undefined' ||
    text.trim() === '' // chỉ khoảng trắng
  )
}

export function validatePhoneNumber(phone) {
  const rawPhone = String(phone ?? '')

  if (rawPhone.trim() === '') {
    return { isValid: false, errorMessage: 'Vui lòng nhập số điện thoại' }
  }

  const cleanPhone = rawPhone.replace(/\D/g, '')

  if (cleanPhone.length === 0) {
    return { isValid: false, errorMessage: 'Vui lòng nhập số điện thoại' }
  }

  if (cleanPhone.length !== 10) {
    return { isValid: false, errorMessage: 'Số điện thoại phải có đúng 10 số' }
  }

  if (!/^0\d{9}$/.test(cleanPhone)) {
    return { isValid: false, errorMessage: 'Số điện thoại phải bắt đầu bằng 0' }
  }

  return { isValid: true, errorMessage: '' }
}
